<!--<h2 mat-dialog-title>{{data.title|translate}}</h2>-->
<div class="mat-typography">
    <tilby-magic-form [form]="data.form"></tilby-magic-form>
</div>
<!--<div mat-dialog-actions align="end">-->
<!--    <button *ngIf="data.buttonCancelLabel" mat-button mat-dialog-close>{{data.buttonCancelLabel|translate}}</button>-->
<!--    <button *ngIf="data.buttonConfirmLabel" mat-button [mat-dialog-close]="data.form.value" [disabled]="data.form.invalid" cdkFocusInitial color="primary">{{(data.buttonConfirmLabel||'DIALOGS.GENERIC_MESSAGE_DIALOG.CONFIRM_BUTTON')|translate}}</button>-->
<!--</div>-->
